import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import ClienteCadEdit from "../pages/Clientes/ClienteCadEdit";
import Clientes from "../pages/Clientes/Clientes";
import AnimaisCadEdit from "../pages/Animais/AnimaisCadEdit";
import Usuarios from "../pages/ConfiguracoesSistema/Usuarios/Usuarios";
import UsuariosCadEdit from "../pages/ConfiguracoesSistema/Usuarios/UsuarioCadEdit";
import EmpresasCadEdit from "../pages/ConfiguracoesSistema/Empresas/EmpresasCadEdit";
import ProfissionalDados from "../pages/Profissionais/ProfissionalDados";
import ProfissionalCadEdit from "../pages/Profissionais/ProfissionalCadEdit";
import Profissionais from "../pages/Profissionais/Profissionais";
import ServicosDados from "../pages/ConfiguracoesSistema/Servicos/ServicoDados";
import ServicosCadEdit from "../pages/ConfiguracoesSistema/Servicos/ServicoCadEdit";
import Servicos from "../pages/ConfiguracoesSistema/Servicos/Servicos";
import Agenda from "../pages/Agenda/Agenda";
import ContasApagar from "../pages/Financas/ContasAPagar/ContasAPagar";
import ContasAReceber from "../pages/Financas/ContasAReceber/ContasAreceber";
import Dashboard from "../pages/Dashboard/Dashboard";
import FichaCLiente from "../pages/Clientes/FichaCliente/FichaCLiente";
import ConfiguracoesSistemaPrincipal from "../pages/ConfiguracoesSistema/ConfiguracoesSistemaPrincipal";
import GruposUsuariosCadEdit from "../pages/ConfiguracoesSistema/Usuarios/GruposUsuarios/GruposUsuariosCadEdit";
import GruposUsuarios from "../pages/ConfiguracoesSistema/Usuarios/GruposUsuarios/GruposUsuarios";
import ProfissionaisFicha from "../pages/Profissionais/FichaProfissional/ProfissionaisFicha";
import AgendaOnlineCadEdit from "../pages/ConfiguracoesSistema/AgendaOnline/AgendaOnlineCadEdit";
import Agenda2 from "../pages/Agenda2/Agenda2";
import ClienteCadastro from "../pages/Clientes/ClienteCadastro";
import AnimaisClientes from "../pages/Animais/AnimaisClientes";
import ClientesAgendamentos from "../pages/Clientes/FichaCliente/ClientesAgendamentos";

const PrivateRoutes = () => {


    return (
        <BrowserRouter>
            <Routes>
                <Route path="/admin/inicio" element={<Dashboard />} />


                /**AGENDA */
                <Route path="/admin/agenda" element={<Agenda />} />
                <Route path="/admin/agenda2" element={<Agenda2 />} />

                /**CLIENTES */
                <Route path="/admin/clientes/:idCliente/agendamentos" element={<ClientesAgendamentos />} />
                <Route path="/admin/clientes/:idCliente/animais" element={<AnimaisClientes />} />
                <Route path="/admin/clientes/:idCliente" element={<ClienteCadEdit />} />
                <Route path="/admin/clientes/cadEdit/:idCliente" element={<ClienteCadEdit />} />
                <Route path="/admin/clientes/cadEdit" element={<ClienteCadEdit />} />
               <Route path="/admin/clientes/cadastro" element={<ClienteCadastro />} />
               
                <Route path="/admin/clientes" element={<Clientes />} />

                /**ANIMAIS */ 
                <Route path="/animais" />
                <Route path="/animais/cadEdit/:idCliente" element={<AnimaisCadEdit />} />
                <Route path="/admin/animais/cadEdit" element={<AnimaisCadEdit />} />


                /**PROFISSIONAIS */
                <Route path="/admin/profissionais/:idProfissional" element={<ProfissionalDados />} />
                <Route path="/admin/profissionais/cadEdit/:idProfissional" element={<ProfissionalCadEdit />} />
                <Route path="/admin/profissionais/cadEdit" element={<ProfissionalCadEdit />} />
                <Route path="/admin/profissionais/ficha/:idProfissional" element={<ProfissionaisFicha />} />
                <Route path="/admin/profissionais" element={<Profissionais />} />

                /**FINANÇAS */
                <Route path="/admin/financas/contasPagar" element={<ContasApagar />} />
                <Route path="/admin/financas/contasReceber" element={<ContasAReceber />} />

                /**CONFIGURAÇÕES */
                <Route path="/admin/configuracoes/usuarios/cadEdit/:idUsuario" element={<UsuariosCadEdit />} />
                <Route path="/admin/configuracoes/usuarios/cadEdit" element={<UsuariosCadEdit />} />
                <Route path="/admin/configuracoes/usuarios" element={<Usuarios />} />

                <Route path="/admin/configuracoes/gruposUsuarios/cadEdit/:idGrupo" element={<GruposUsuariosCadEdit />} />
                <Route path="/admin/configuracoes/gruposUsuarios/cadEdit" element={<GruposUsuariosCadEdit />} />
                <Route path="/admin/configuracoes/gruposUsuarios" element={<GruposUsuarios />} />



                <Route path="/admin/configuracoes/empresas" element={<EmpresasCadEdit />} />
                <Route path="/admin/configuracoes/servicos/:idServico" element={<ServicosDados />} />
                <Route path="/admin/configuracoes/servicos/cadEdit/:idServico" element={<ServicosCadEdit />} />
                <Route path="/admin/configuracoes/servicos/cadEdit" element={<ServicosCadEdit />} />
                <Route path="/admin/configuracoes/servicos" element={<Servicos />} />
                <Route path="/admin/configuracoes/agendaOnline" element={<AgendaOnlineCadEdit />} />
                <Route path="/admin/configuracoes" element={<ConfiguracoesSistemaPrincipal />} />



                <Route path="*" element={<Navigate to="/admin/inicio" />} />
            </Routes>
        </BrowserRouter>

    )
}
export default PrivateRoutes;